import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminFFLState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}
// const defaultColumnList = [
//   {
//     name: 'business_name',
//     label_key: 'business_name',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     type: 'text',
//     filter_placeholder: 'business_name',
//     order: 1,
//   },
//   {
//     name: 'name',
//     label_key: 'name',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 2,
//   },
//   {
//     name: 'email',
//     label_key: 'email_address',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 3,
//   },
//   {
//     name: 'mobile',
//     label_key: 'phone_number',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 4,
//   },
//   {
//     name: 'subscription',
//     label_key: 'subscription',
//     allow_list: false,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 5,
//   },
//   {
//     name: 'subscription_period',
//     label_key: 'subscription_period',
//     allow_list: false,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 6,
//   },
//   {
//     name: 'state',
//     label_key: 'state',
//     allow_list: true,
//     allow_filter: true,
//     show_list_checkbox: true,
//     show_filter_checkbox: true,
//     type: 'asyncselect',
//     asyncKey: 'states',
//     filter_placeholder: 'state_all',
//     option_value_key: 'id',
//     option_label_key: 'full_name',
//     multi: true,
//     order: 7,
//   },
//   {
//     name: 'ffl_no',
//     label_key: 'ffl',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 8,
//   },
//   {
//     name: 'ffl_expiry_date',
//     label_key: 'expiry_date',
//     allow_list: true,
//     allow_filter: false,
//     show_list_checkbox: true,
//     show_filter_checkbox: false,
//     order: 9,
//   },
//   {
//     name: 'ffl_verified',
//     label_key: 'ffl_status',
//     allow_list: true,
//     allow_filter: true,
//     show_list_checkbox: true,
//     show_filter_checkbox: true,
//     type: 'select',
//     filter_placeholder: 'ffl_all',
//     selectKey: 'ffl_status',
//     option_value_key: 'slug',
//     option_label_key: 'name',
//     multi: false,
//     order: 10,
//   },
//   {
//     name: 'status',
//     label_key: 'status',
//     allow_list: true,
//     allow_filter: true,
//     show_list_checkbox: true,
//     show_filter_checkbox: true,
//     type: 'select',
//     filter_placeholder: 'status_all',
//     selectKey: 'status',
//     option_value_key: 'id',
//     option_label_key: 'name',
//     multi: false,
//     order: 11,
//   },
// ];
const defaultColumnList = [
  {
    name: 'ffl_info',
    label_key: 'ffl_info',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'products',
    label_key: 'products',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'orders',
    label_key: 'orders',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 3,
  },
  {
    name: 'revenue',
    label_key: 'revenue',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 4,
  },
  {
    name: 'subscription',
    label_key: 'subscription',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 5,
  },
  {
    name: 'ffl_verified',
    label_key: 'ffl_status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'ffl_all',
    selectKey: 'ffl_status',
    option_value_key: 'slug',
    option_label_key: 'name',
    multi: false,
    order: 6,
  },
  {
    name: 'state',
    label_key: 'state',
    allow_list: false,
    allow_filter: true,
    show_list_checkbox: false,
    show_filter_checkbox: true,
    type: 'asyncselect',
    asyncKey: 'states',
    filter_placeholder: 'state_all',
    option_value_key: 'id',
    option_label_key: 'full_name',
    multi: false,
    order: 7,
  },
  {
    name: 'membership',
    label_key: 'membership',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 8,
  },
  {
    name: 'activity',
    label_key: 'activity',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 9,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 10,
  },
];
const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));
const initialState: AdminFFLState = {
  excludedFilter: ['search'],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminFFLSlice = createSlice({
  name: 'adminFFL',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = action.payload;
    },
    removeFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
    setFFLTableColumnList(state, action: PayloadAction<TableSettingColumn[]>) {
      state.tableColumnList = action.payload;
    },
  },
});

export const {
  setFilterData,
  removeFilterKey,
  resetFilterData,
  setReloadTableData,
  setFFLTableColumnList,
} = adminFFLSlice.actions;

export default adminFFLSlice.reducer;
